import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, Stack, Typography } from '@mui/material'

import { Message } from '../../helpers/writeMessages'

export type Notice = { severity: 'error' | 'warning' | 'success'; messages: Message[] }

// Stays until closed: a read-back that doesn't show what was sent mustn't flash by.
export const WriteNotice: FC<{ notice?: Notice; onClose: () => void }> = ({ notice, onClose }) => {
  const { t } = useTranslation()
  if (!notice) return null
  return (
    <Alert severity={notice.severity} onClose={onClose} sx={{ mb: 2 }} role="alert">
      <Stack spacing={0.5}>
        {notice.messages.map(({ key, options }, index) => (
          <Typography key={`${key}-${index}`} variant="body2">
            {t(key, options)}
          </Typography>
        ))}
      </Stack>
    </Alert>
  )
}
